import React, { Fragment, Component } from "react";
import PropTypes from "prop-types";
import { Route } from "react-router";
import { connect } from "react-redux";
import { getSearchSettings } from "./store/search/selectors";
import { SearchScreenContainer } from "./screens/SearchScreen/SearchScreenContainer";
import { SearchOptionScreenContainer } from "./screens/SearchOptionScreen/SearchOptionScreenContainer";

import "./assets/scss/main.scss";
import SimpleUrl from "./store/search/SimpleUrl";
import { appLoaded, setSearchSettings } from "./store/search/actions";

class App extends Component {
  static propTypes = {
    location: PropTypes.object.isRequired,
  };
  constructor(props) {
    super(props);
    this.toggleChange = this.toggleChange.bind(this);
  }


  toggleChange = () => {
      this.props.updateSettings();
      this.props.fetchFilters(window.location);
  }

  componentDidMount() {
    document.getElementById('PersonalBusinessToggle')?.addEventListener('change', this.toggleChange);
  }

  componentWillUnmount() {
    document.getElementById('PersonalBusinessToggle')?.removeEventListener('change', this.toggleChange);
  }

  render() {
    const { searchSettings } = this.props;
    const {
      pageUrl = "/search",
      routes = [],
    } = searchSettings;
    const simpleUrl = new SimpleUrl(routes, pageUrl);
    const searchRoutes = simpleUrl.getRoutes();
    return (
      <Fragment>
        <Route path="/home" component={SearchOptionScreenContainer} />
        <Route exact path={pageUrl} component={SearchScreenContainer} />
            {searchRoutes.map((route, i) => (
              <Route
                key={i}
                exact
                path={`${pageUrl}${route.path}`}
                component={SearchScreenContainer}
              />
            ))}
        <Route path="/" exact component={SearchScreenContainer} />
      </Fragment>
    );
  }
}
const mapStateToProps = state => {
  return {
    searchSettings: getSearchSettings(state),
  };
};

const mapDispatchToProps = dispatch => ({
  updateSettings: () => dispatch(setSearchSettings()),
  fetchFilters: (history) => dispatch(appLoaded(history)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(App);
